import React, { Component } from 'react';

import Card from 'react-bootstrap/Card';

import './Ide.css';

class Ide extends Component {

    render() {

        const bootstrapTextMuted = '#6c757d';

        return (
            <Card id='ide' bg='dark' border='secondary' text='muted' className='drop-shadow' style={{'borderRadius': '0.6rem'}}>

                <Card.Header>
                    <span className='float-start'>
                        {this.getButton(bootstrapTextMuted)}
                        {this.getButton(bootstrapTextMuted)}
                        {this.getButton(bootstrapTextMuted)}
                        <span className='ps-4'>{this.props.filename}</span>
                    </span>
                    <span>{this.props.title}</span>
                </Card.Header>

                <Card.Body>
                    <div className='text-start card-text'>
                        <code className='font-monospace' style={{ 'fontSize': '1.2rem' }}>
                            {this.props.code}
                        </code>
                    </div>
                </Card.Body>

            </Card>
        );
    }

    getButton(color) {
        return (
            <svg height='20' width='20'>
                <circle cx='10' cy='10' r='5' fill={color} />
            </svg>
        );
    }

}

export default Ide;